import { getWallets, type WalletsApi } from './controller'

export const useWallets = (): WalletsApi => getWallets()
